// extracted by mini-css-extract-plugin
export default {"Switch":"yjeL8G7T7ORzzZ5FLv70","disabled":"JJCrOZ1VZuMPLWVP_1xs"};